import { ChadGPTTool } from "./ChadGPTTool";

export const ChadGPTWrapper = () => {
  return (
    <main className="w-full flex h-fit  flex-col px-5 md:px-10 py-10 relative">
      <h2 className="text-[22px] text-neutral-200 font-semibold uppercase">
        CHADGpt
      </h2>
      <ChadGPTTool />
    </main>
  );
};
